export const FREE_DESSERT = 'Free Dessert';
export const SPONGEBOB_SQUAREPANTS = 'SpongeBob SquarePants';

export const SIDES = 'Sides';

export const MY_FAVORITES = 'myFavorites';

export const ORDER_AGAIN_FILTER_KEY = 'orderAgain';

export const FILTERED_MEALS_NO_RESULTS_SUBHEADING =
  "We're sorry, we couldn't find any meals that match your filters! We recommend trying other combinations or exploring different menus.";

export const MEAL_FILTERS = [
  'Protein-Packed',
  'Calorie-Conscious',
  'Fiber-Rich',
  'Dietitian Approved',
];

export const VISIBLE_FILTER_OPTIONS_LIMIT = 8;

export const MAX_MEAL_BADGE_QUICK_FILTERS = 3;
